import foo from './foo';

const rootSubscribe = (store) => () => {};

export default rootSubscribe;
